import styled from "styled-components/macro";
import { Select } from "@gcs/design-system/react";

export const SelectInput = styled(Select)(({ theme }) => ({
  div: {
    background: theme.color.neutral["08"],
    color: theme.color.neutral["03"],
  },
  label: {
    fontSize: "16px",
    [theme.breakpoint.md()]: {
      fontSize: "18px",
    },
  },
  input: {
    fontSize: "16px",
    [theme.breakpoint.md()]: {
      fontSize: "18px",
    },
  },
  ul: {
    maxHeight: "150px",
    overflowY: "auto",
    zIndex: 9999,
  },
}));

export const Item = styled(Select.Item)(({ theme }) => ({
  zIndex: 9999,
  color: theme.color.neutral["03"],
  fontSize: "16px",
  [theme.breakpoint.md()]: {
    fontSize: "18px",
  },
}));

export const SelectContainer = styled.div(({ theme, disabled }) => ({
  pointerEvents: disabled ? 'none' : 'default',
  ">div>div": {
    background: disabled ? theme.color.neutral["06"] : theme.color.neutral["08"]
  },
  label: {
    display: "flex",
    marginBottom: "8px",
    alignItems: "center",
    fontWeight: 500,
    lineHeight: "150%",
    fontSize: "16px",
    [theme.breakpoint.md()]: {
      fontSize: "18px",
    },
  },
}));

export const RequiredIcon = styled.p(({ theme }) => ({
  color: theme.color.feedback.error,
}))

export const ErrorMessage = styled.h6(({ theme }) => ({
  textAlign: "inherit",
  display: "flex",
  alignItems: "center",
  svg: {
    margin: "0 5px 0 0",
    width: "1rem",
  },
  color: theme.color.feedback.error,
  marginTop: 0,
  marginBottom: 0,
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "150%",
}));

export const SelectTitle = styled.p(({ theme, error }) => ({
  fontSize: "16px",
  display: "flex",
  color: error ? theme.color.feedback.error : theme.color.neutral["02"],
  marginBottom: "8px",
  fontFamily: "Rawline",
  alignItems: "center",
  fontWeight: "500",
  lineHeight: "150%",
  letterSpacing: 0,
  [theme.breakpoint.md()]: {
    fontSize: "18px",
  },
}))